<template>
    <v-textarea :value="value" rows="1" v-model="internal" auto-grow @input="onChange()" :label="label">
    </v-textarea>
</template>

<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      internal: ""
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.internal);
    }
  },
  created() {
    this.internal = this.value;
  },
  watch: {
    value() {
      this.internal = this.value;
    }
  }
};
</script>

